.root {
  font-size: 14px;
  line-height: 1.65;
  color: var(--color-text-muted);
}

.h1 {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  color: var(--color-text);
}

.h2 {
  margin: 24px 0 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
  color: var(--color-text);
}

.h2:first-child {
  margin-top: 0;
}

.paragraph {
  margin: 0 0 12px;
}

.list {
  margin: 0 0 12px;
  padding-left: 20px;
}

.list li {
  margin-bottom: 6px;
}

.list li:last-child {
  margin-bottom: 0;
}
